import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import FaqInterface, {
  FaqItemInterface,
} from 'common/types/entities/FaqInterface'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createFaq(
  parentId: string,
  masterBlockId?: MasterBlockId,
): FaqInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Faq, parentId, masterBlockId),
    childIds: [],
    showIcons: true,
    mobileShowIcons: true,
    iconClassName: 'fas fa-chevron-circle-up',
    iconColor: 'rgba(24, 24, 24, 1)',
    backgroundColor: 'rgba(241, 244, 248, 1)',
    titleColor: 'rgba(24, 24, 24, 1)',
    titleFontSize: 16,
    spaceBetweenItems: 10,
    itemBorderRadius: 5,
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    itemPadding: {
      paddingTop: 15,
      paddingRight: 15,
      paddingBottom: 15,
      paddingLeft: 20,
    },
    mobileItemPadding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 15,
    },
  }
}

export function createFaqAnswer(
  parentId: string,
  masterBlockId?: MasterBlockId,
  creationItemNumber = 1,
): FaqItemInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.FaqItem, parentId, masterBlockId),
    parentId,
    creationItemNumber: creationItemNumber,
    title: '',
    childIds: [],
  }
}
